<script>
  import { line, area } from "d3-shape";
  import { scaleLinear } from "d3-scale";
  import { extent } from "d3-array";
  export let width;
  export let height;
  export let sparkLineData;
  export let sparkLineDataLabel;
  export let maxFrequency;
  export let lineColor;
  export let index;
  export let labels;

  const margin = { top: 10, right: 40, bottom: 4, left: 10 };
  const chartWidth = width - margin.left - margin.right;
  const chartHeight = height - margin.top - margin.bottom;

  const xDomain = extent(sparkLineData, (d) => d.year);
  let x = scaleLinear().domain(xDomain).range([0, chartWidth]);
  $: yDomain = [0, $maxFrequency];
  $: y = scaleLinear().domain(yDomain).range([chartHeight, 0]);

  $: lineGenerator = line()
    .x((d) => x(d.year))
    .y((d) => y(d.number));

  $: areaGenerator = area()
    .x((d) => x(d.year))
    .y1((d) => y(d.number))
    .y0(y(0));
</script>

<svg {width} {height}>
  <g transform={`translate(${margin.left}, ${margin.top})`}>
    <path
      class="frequency-area"
      d={areaGenerator(sparkLineData)}
      fill="#dddddd"
      stroke-width={0}
    />
    <path
      class="frequency-line"
      d={lineGenerator(sparkLineData)}
      fill="none"
      stroke={lineColor}
      stroke-width={2}
    />
    <circle cx={chartWidth} cy={y(sparkLineDataLabel)} r={3} fill={lineColor} />
    <text
      class="sparkline-label"
      x={chartWidth + 6}
      y={y(sparkLineDataLabel)}
      dy={"0.4rem"}>{sparkLineDataLabel}</text
    >
    {#if index === 0 && labels}
      <text x={x(xDomain[0])} y={-6} class="axis-label">{xDomain[0]}</text>
      <text x={x(xDomain[1])} y={-6} class="axis-label">{xDomain[1]}</text>
    {/if}
  </g>
</svg>

<style>
  svg {
    overflow: visible;
  }
  .sparkline-label {
    font-size: 20px;
  }
  .axis-label {
    text-anchor: middle;
    fill: #bbb;
    font-weight: 100;
  }
</style>
